import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import {MembersUpdateComponent} from './members-update/members-update.component';
import {MembersComponent} from './members/members.component';
import {RouterModule} from '@angular/router';
import {membersRoute} from './members-routing.module';

@NgModule({
    imports: [SharedModule, RouterModule.forChild(membersRoute)],
    declarations: [MembersUpdateComponent, MembersComponent],
})
export class MembersModule { }
